/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_ProhibitedInputs */



/**
* | output |
* | --- |
* | "Read only" |
*
* @param {Agent_Builder_Confirmation_ProhibitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_prohibited = /** @type {((inputs?: Agent_Builder_Confirmation_ProhibitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_ProhibitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur lesen")
	return /** @type {LocalizedString} */ ("Read only")
});